module.exports = __webpack_public_path__ + "img/New-Zealand.3ec44c5f.png";